import { defaultMumbaiProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/mumbai/default-constants';

export const QUICK_SWAP_MUMBAI_CONTRACT_ADDRESS = '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff';

export const QUICK_SWAP_MUMBAI_PROVIDER_CONFIGURATION = defaultMumbaiProviderConfiguration;
